
// Topic 1 First
// Topic 2 First
// Topic 3 First
// Topic 4 First
// Topic 5 First


// Topic 1 Second
// Topic 2 Second
// Topic 3 Second
// Topic 4 Second
// Topic 5 Second


// Topic 1 Third
// Topic 2 Third
// Topic 3 Third
// Topic 4 Third


// Topic 1 Fourth
// Topic 2 Fourth
// Topic 3 Fourth
// Topic 4 Fourth
// Topic 5 Fourth
// Topic 6 Fourth


// French Videos


export const firstFormCourseTopicMaterials = [
  {
    id: 'panel1',
    ariaControls: 'panel1d-content',
    headerId: 'panel1d-header',
    topic: 'Topic 1: Parts of Speech',
    details: 'All words can be classified into eight parts of speech, which play a vital role in helping people to communicate. Parts of speech are nouns, pronouns, verbs, adjectives, adverbs, prepositions, conjunctions, and interjections.',
    videos: [
      {id: '1NPV', label: 'Nouns and Pronouns', url: process.env.REACT_APP_FIRST_NOUNS_PRONOUNS, lazyLoad: true},
      {id: '1VV',  label: 'Verbs', url: process.env.REACT_APP_FIRST_VERBS, lazyLoad: true},
      {id: '1AAV', label: 'Adjectives and Adverbs', url: process.env.REACT_APP_FIRST_ADJECTIVES_ADVERBS, lazyLoad: true},
      {id: '1PV',  label: 'Prepositions', url: process.env.REACT_APP_FIRST_PREPOSITIONS, lazyLoad: true},
      {id: '1CIV', label: 'Conjunction and Interjection', url: process.env.REACT_APP_FIRST_CONJ_INTER, lazyLoad: true},
    ],
  },
  {
    id: 'panel2',
    ariaControls: 'panel2d-content',
    headerId: 'panel2d-header',
    topic: 'Topic 2: Parts of a Sentence',
    details: 'Every sentence can be divided into four types of sentences, and it contains three parts. The four types of sentences are declarative, interrogative imperative, or exclamatory. The three main parts of a sentence are subject, predicate, and complement.',
    videos: [
      {id: '1SSPV', label: 'Simple Subject and Predicate', url: process.env.REACT_APP_FIRST_SIMP_SUB_PRED, lazyLoad: true},
      {id: '1CSPV', label: 'Complete Subject and Predicate', url: process.env.REACT_APP_FIRST_COMP_SUB_PRED, lazyLoad: true},
      {id: '1DIOV', label: 'Direct and Indirect Objects', url: process.env.REACT_APP_FIRST_DIR_IND_OBJECTS, lazyLoad: true},
      {id: '1NIOV', label: 'Normal and Inverted Order', url: process.env.REACT_APP_FIRST_NORM_INV_ORDER, lazyLoad: true},
      {id: '1TSV',  label: 'Types of Sentences', url: process.env.REACT_APP_FIRST_TYPES_SENTENCES, lazyLoad: true},
    ],
  },
  {
    id: 'panel3',
    ariaControls: 'panel3d-content',
    headerId: 'panel3d-header',
    topic: 'Topic 3: Phrases',
    details: 'Every sentence may contain phrases which can be identified into five types that aim to add details. The five types of phrases are prepositional, appositive, participial, gerund, and infinitive.',
    videos: [
      {id: '1PRPV', label: 'Prepositional Phrases', url: process.env.REACT_APP_FIRST_PREPOSITIONAL_PHRASES, lazyLoad: true},
      {id: '1APPV', label: 'Appositive Phrases', url: process.env.REACT_APP_FIRST_APPOSITIVE_PHRASES, lazyLoad: true},
      {id: '1PPV',  label: 'Participial Phrases', url: process.env.REACT_APP_FIRST_PARTICIPIAL_PHRASES, lazyLoad: true},
      {id: '1GPV',  label: 'Gerund Phrases', url: process.env.REACT_APP_FIRST_GERUND_PHRASES, lazyLoad: true},
      {id: '1IPV',  label: 'Infinitive Phrases', url: process.env.REACT_APP_FIRST_INFINITIVE_PHRASES, lazyLoad: true},
    ],
  },
  {
    id: 'panel4',
    ariaControls: 'panel4d-content',
    headerId: 'panel4d-header',
    topic: 'Topic 4: Clauses',
    details: 'Every sentence may contain clauses which are divided into two main parts. The two parts are the main clause and the subordinate clause. Subordinate clauses are classified as adjective, adverb, or noun. With the help of the main clause and subordinate clauses, sentences can be classified by four types of sentence structures. The four types of sentence structures are simple, compound, complex, and compound-complex.',
    videos: [
      {id: '1MCV',  label: 'Main Clause', url: process.env.REACT_APP_FIRST_MAIN_CLAUSE, lazyLoad: true},
      {id: '1SCV',  label: 'Subordinate Clauses', url: process.env.REACT_APP_FIRST_SUBORDINATE_CLAUSES, lazyLoad: true},
      {id: '1ACV',  label: 'Adjective Clauses', url: process.env.REACT_APP_FIRST_ADJECTIVE_CLAUSES, lazyLoad: true},
      {id: '1ADCV', label: 'Adverb Clauses', url: process.env.REACT_APP_FIRST_ADVERB_CLAUSES, lazyLoad: true},
      {id: '1NCV',  label: 'Noun Clauses', url: process.env.REACT_APP_FIRST_NOUN_CLAUSES, lazyLoad: true},
      {id: '1SCSV', label: 'Simple and Compound Sentences', url: process.env.REACT_APP_FIRST_SIMP_COMP_SENTENCES, lazyLoad: true},
      {id: '1CCCSV', label: 'Complex and Compound Complex sentences', url: process.env.REACT_APP_FIRST_COMPL_COMP_COMPLEX_SENTENCES, lazyLoad: true},
    ],
  },
  {
    id: 'panel5',
    ariaControls: 'panel5d-content',
    headerId: 'panel5d-header',
    topic: 'Topic 5: Writing',
    details: 'These videos capture the basic types of writing taught at the 1st form level. Students solidify their previous knowledge of basic paragraph writing, they review literary devices and imagery, and they practice two types of writing. Students begin to explore expository writing with compare and contrast, and they also explore descriptive writing with order of importance.',
    videos: [
      {id: '1BPV', label: 'Basic Paragraph', url: process.env.REACT_APP_FIRST_BASIC_PARAGRAPH, lazyLoad: true},
      {id: '1CCV', label: 'Compare and Contrast', url: process.env.REACT_APP_FIRST_COMP_CONTR_WRITING, lazyLoad: true},
      {id: '1IWV', label: 'Imagery', url: process.env.REACT_APP_FIRST_IMAGERY, lazyLoad: true},
      {id: '1LDWV', label: 'Literary Devices', url: process.env.REACT_APP_FIRST_LITERARY_DEVICES, lazyLoad: true},
      {id: '1PWOOV', label: 'Paragraph Writing Order of Importance', url: process.env.REACT_APP_FIRST_PARA_WRITING_OOI, lazyLoad: true},
    ],
  },
];

export const secondFormCourseTopicMaterials = [
  {
    id: 'panel1',
    ariaControls: 'panel1d-content',
    headerId: 'panel1d-header',
    topic: 'Topic 1: Phrases',
    details: 'Every sentence may contain phrases which can be identified into five types that aim to add details. The five types of phrases are prepositional, appositive, participial, gerund, and infinitive.',
    videos: [
      {id: '2IFV', label: 'Infinitive Phrases', url: process.env.REACT_APP_SECOND_INFINITIVE_PHRASES, lazyLoad: true},
      {id: '2PGV', label: 'Participial and Gerunds', url: process.env.REACT_APP_SECOND_PARTICIPLES_GERUNDS, lazyLoad: true},
      {id: '2PAV', label: 'Prepositional and Appositive Phrases', url: process.env.REACT_APP_SECOND_PREP_APPOSITIVE, lazyLoad: true},
    ],
  },
  {
    id: 'panel2',
    ariaControls: 'panel2d-content',
    headerId: 'panel2d-header',
    topic: 'Topic 2: Sentence Structure',
    details: 'Every sentence may contain clauses which are divided into two main parts. The two parts are the main clause and the subordinate clause. Subordinate clauses are classified as adjective, adverb, or noun. With the help of the main clause and subordinate clauses, sentences can be classified by four types of sentence structures. The four types of sentence structures are simple, compound, complex, and compound-complex.',
    videos: [
      {id: '2MSCV', label: 'Main and Subordinate Clauses', url: process.env.REACT_APP_SECOND_MAIN_SUB_CLAUSES, lazyLoad: true},
      {id: '2NCV',  label: 'Noun Clauses', url: process.env.REACT_APP_SECOND_NOUN_CLAUSES, lazyLoad: true},
      {id: '2SCSV', label: 'Simple and Compound Sentences', url: process.env.REACT_APP_SECOND_SIMPLE_COMP_SENTENCES, lazyLoad: true},
      {id: '2CCCV', label: 'Complex and Compound Complex Sentences', url: process.env.REACT_APP_SECOND_COMPOUND_COMPLEX_SENTENCES, lazyLoad: true},
    ],
  },
  {
    id: 'panel3',
    ariaControls: 'panel3d-content',
    headerId: 'panel3d-header',
    topic: 'Topic 3: Subject Verb Agreement',
    details: 'Subject verb agreement rules ensure that the subject of the sentence agrees with its verb. If the subject is singular, the verb will be singular. If the subject is plural, the verb will be plural. Subject verb agreement rules also ensure special exceptions also follow singular and plural agreements.',
    videos: [
      {id: '2AAPV',  label: 'Active and Passive Voice', url: process.env.REACT_APP_SECOND_ACTIVE_PASSIVE_VOICE, lazyLoad: true},
      {id: '2CLNV',  label: 'Collective Nouns', url: process.env.REACT_APP_SECOND_COLLECTIVE_NOUNS, lazyLoad: true},
      {id: '2CMPSV', label: 'Compound Subjects', url: process.env.REACT_APP_SECOND_COMPOUND_SUBJECTS, lazyLoad: true},
      {id: '2INDPV', label: 'Indefinite pronouns', url: process.env.REACT_APP_SECOND_INDEFINITE_PRONOUNS, lazyLoad: true},
      {id: '2ISLVV', label: 'Inverted Sentence and Linking Verbs', url: process.env.REACT_APP_SECOND_INV_LINKING_VERBS, lazyLoad: true},
      {id: '2ONATV', label: 'Nouns of Amount and Titles', url: process.env.REACT_APP_SECOND_NOUNS_AMOUNT_TITLES, lazyLoad: true},
    ],
  },
  {
    id: 'panel4',
    ariaControls: 'panel4d-content',
    headerId: 'panel4d-header',
    topic: 'Topic 4: Short Stories',
    details: "Narrative writing is fictional and nonfictional writing – short stories. This type of writing brings forth the author’s unique writing skills to display vivid setting, dramatic characterization, and captivating plots. Narrative writing also displays a vast literary device usage.",
    videos: [
      {id: '2CHV',  label: 'Characterization', url: process.env.REACT_APP_SECOND_CHARACTERIZATION, lazyLoad: true},
      {id: '2MTV',  label: 'Mood and Tone', url: process.env.REACT_APP_SECOND_MOOD_AND_TONE, lazyLoad: true},
      {id: '2PLTV', label: 'Plot', url: process.env.REACT_APP_SECOND_PLOT, lazyLoad: true},
      {id: '2ESSV', label: 'Elements of a Short Story', url: process.env.REACT_APP_SECOND_ELEMENTS_SHORT_STORY, lazyLoad: true},
    ],
  },
  {
    id: 'panel5',
    ariaControls: 'panel5d-content',
    headerId: 'panel5d-header',
    topic: 'Topic 5: Writing',
    details: 'Expository writing allows students to gather information objectively, and present their writing to inform, explain, or describe. In addition, this form develops informative discourse pieces – letter writing, emails, and summary, which aims to create formal and informal pieces that describes an object, extracts relevant and pertinent information, or present clarification and solutions to a concept.',
    videos: [
      {id: '2EAGV', label: 'Attention Grabber', url: process.env.REACT_APP_SECOND_ATTENTION_GRABBER, lazyLoad: true},
      {id: '2ESV',  label: 'Essay Structure', url: process.env.REACT_APP_SECOND_ESSAY_STRUCTURE, lazyLoad: true},
      {id: '2LEWV', label: 'Letter and Email Writing', url: process.env.REACT_APP_SECOND_LETTER_EMAIL_WRITING, lazyLoad: true},
      {id: '2SWV',  label: 'Summary Writing', url: process.env.REACT_APP_SECOND_SUMMARY_WRITING, lazyLoad: true},
    ],
  },
];

export const thirdFormCourseTopicMaterials = [
  {
    id: 'panel1',
    ariaControls: 'panel1d-content',
    headerId: 'panel1d-header',
    topic: 'Topic 1: Verbs',
    details: 'This unit reviews the principal parts of verbs, verbs tenses, and subject verb agreement rules. Further in-depth study of verbs allows students to use voice and mood of verbs to improve their written communicative skills.',
    videos: [
      {id: '3POVV', label: 'Parts Of Verbs', url: process.env.REACT_APP_THIRD_VERBS, lazyLoad: true},
      {id: '3SITV', label: 'Simple Tenses', url: process.env.REACT_APP_THIRD_SIMPLE_TENSES, lazyLoad: true},
      {id: '3SVA1V', label: 'Subject Verb Agreement Part 1', url: process.env.REACT_APP_THIRD_SVA_ONE, lazyLoad: true},
      {id: '3SVA2V', label: 'Subject Verb Agreement Part 2', url: process.env.REACT_APP_THIRD_SVA_TWO, lazyLoad: true},
      {id: '3LVLV', label: 'Lie vs Lay', url: process.env.REACT_APP_THIRD_LIE_LAY, lazyLoad: true},
      {id: '3SSRRV', label: 'Sit Set Rise Raise', url: process.env.REACT_APP_THIRD_SIT_SET_RISE_RAISE, lazyLoad: true},
      {id: '3VOVV', label: 'Voice of Verbs', url: process.env.REACT_APP_THIRD_VOICE_OF_VERBS, lazyLoad: true},
      {id: '3MOVV', label: 'Mood Of Verbs', url: process.env.REACT_APP_THIRD_MOOD_OF_VERBS, lazyLoad: true},
    ],
  },
  {
    id: 'panel2',
    ariaControls: 'panel2d-content',
    headerId: 'panel2d-header',
    topic: 'Topic 2: Pronouns',
    details: 'Pronouns are words used to refer to persons or things. They have three cases or forms called nominative, objective, or possessive. Each case is determined by how the pronoun functions in the sentence. It can be a subject, a complement, or an object. Pronouns also follow specific rules to ensure subject verb agreement rules.',
    videos: [
      {id: '3PCV',  label: 'Pronoun Cases', url: process.env.REACT_APP_THIRD_PRONOUN_CASES, lazyLoad: true},
      {id: '3FOPV', label: 'Functions of Pronouns', url: process.env.REACT_APP_THIRD_FUNCTIONS_PRONOUNS, lazyLoad: true},
      {id: '3RIPV', label: 'Reflexive and Intensive Pronouns', url: process.env.REACT_APP_THIRD_REFLEXIVE_INTENSIVE, lazyLoad: true},
      {id: '3PAV', label: 'Pronouns as Appositives', url: process.env.REACT_APP_THIRD_PRONOUNS_APPOSITIVES, lazyLoad: true},
      {id: '3PAAV', label: 'Pronoun Antecedent Agreement', url: process.env.REACT_APP_THIRD_PRO_ANTE_AGREEMENT, lazyLoad: true},
    ],
  },
  {
    id: 'panel3',
    ariaControls: 'panel3d-content',
    headerId: 'panel3d-header',
    topic: 'Topic 3: Modifiers',
    details: 'Modifiers are adjectives and adverbs in a sentence. They have three degrees of comparisons – positive, comparative, and superlative. Modifiers agree with the degree of comparison being made in the sentence. They also follow specific rules to guide irregular comparisons, double and incomplete comparisons, double negatives, and misplaced and dangling modifiers.',
    videos: [
      {id: '3DOMV',  label: 'Degrees of Modifiers', url: process.env.REACT_APP_THIRD_DEGREE_MODIFIERS, lazyLoad: true},
      {id: '3DNV',   label: 'Double Negatives', url: process.env.REACT_APP_THIRD_DOUBLE_NEGATIVES, lazyLoad: true},
      {id: '3ICGBB', label: 'Incomplete Comparison, Good, Bad, and Badly', url: process.env.REACT_APP_THIRD_INCOMPLETE_COMPARISON, lazyLoad: true},
      {id: '3MDMWO', label: 'Misplaced and Dangling Modifiers', url: process.env.REACT_APP_THIRD_MISPLACED_DANGLING_MOD, lazyLoad: true},
      {id: '3WAWV',  label: 'Who and Whom', url: process.env.REACT_APP_THIRD_WHO_WHOM, lazyLoad: true},
    ],
  },
  {
    id: 'panel4',
    ariaControls: 'panel4d-content',
    headerId: 'panel4d-header',
    topic: 'Topic 4: CSEC SBA',
    details: 'The CSEC English School based assessment portfolio is a collection of each student’s work on the investigation of the issue selected by the group. School-Based Assessment is an integral part of student assessment in the course covered by the Syllabus. It is intended to assist students in acquiring certain knowledge, skills and attitudes that are associated with the subject. The activities for the school-Based Assessment are linked to the Syllabus and contain evidence of the candidate’s planning of the investigation, interacting with and reflecting on stimuli (pieces of material) and writing a report.',
    videos: [
      {id: '3SBATV', label: 'SBA Topics', url: process.env.REACT_APP_THIRD_SBA_TOPICS, lazyLoad: true},
      {id: '3AMLARV', label: 'Artefacts and MLA Referencing', url: process.env.REACT_APP_THIRD_ARTEFACTS_MLA, lazyLoad: true},
      {id: '3POIV', label: 'Plan of Investigation', url: process.env.REACT_APP_THIRD_PLAN_INVESTIGATION, lazyLoad: true},
    ],
  }
];

export const fourthFormCourseTopicMaterials = [

  {
    id: 'panel1',
    ariaControls: 'panel1d-content',
    headerId: 'panel1d-header',
    topic: 'Topic 1: CSEC SBA',
    details: 'The CSEC English School based assessment portfolio is a collection of each student’s work on the investigation of the issue selected by the group. School-Based Assessment is an integral part of student assessment in the course covered by the Syllabus. It is intended to assist students in acquiring certain knowledge, skills and attitudes that are associated with the subject. The activities for the School-Based Assessment are linked to the Syllabus and contain evidence of the candidate’s planning of the nvestigation, interacting with and reflecting on stimuli (pieces of material) and writing a report.',
    videos: [
      {id: '4ICSPV', label: 'Intro to CSEC SBA and POI', url: process.env.REACT_APP_FOURTH_VIDEO_INTRO_POI, lazyLoad: true},
      {id: '4SCPPV', label: 'SBA Cover Page and POI', url: process.env.REACT_APP_FOURTH_VIDEO_COVER_PAGE_POI, lazyLoad: true},
      {id: '4STCRV', label: 'SBA Table of Contents and Reflection 1', url: process.env.REACT_APP_FOURTH_VIDEO_CONTENTS_REFLECTION, lazyLoad: true},
      {id: '4SR2V', label: 'SBA Reflection 2', url: process.env.REACT_APP_FOURTH_VIDEO_SBA_REFLECTION, lazyLoad: true},
      {id: '4SFR12V', label: 'Finalize Reflection 1 and 2', url: process.env.REACT_APP_FOURTH_VIDEO_FINALIZE_REFLECTION, lazyLoad: true},
      {id: '4SOPV', label: 'SBA Oral Presentation', url: process.env.REACT_APP_FOURTH_VIDEO_ORAL_PRESENTATION, lazyLoad: true},
      {id: '4SPRV', label: 'SBA Participation Rubric', url: process.env.REACT_APP_FOURTH_VIDEO_PARTICIPATION, lazyLoad: true},
    ],
  },
  {
    id: 'panel2',
    ariaControls: 'panel2d-content',
    headerId: 'panel2d-header',
    topic: 'Topic 2: Facts & Opinions',
    details: 'This unit builds critical thinking skills which allows students to differentiate between facts and opinions. Facts are based on observations and research, while opinions are based on feelings and thinking.',
    videos: [
      {id: '4WIAEV', label: 'What is an Essay', url: process.env.REACT_APP_FOURTH_VIDEO_WHAT_IS_ESSAY, lazyLoad: true},
      {id: '4FAOV', label: 'Facts and Opinions', url: process.env.REACT_APP_FOURTH_VIDEO_FACTS_OPINIONS, lazyLoad: true},
    ],
  },
  {
    id: 'panel3',
    ariaControls: 'panel3d-content',
    headerId: 'panel3d-header',
    topic: 'Topic 3: Thesis Statement & Full Thesis',
    details: 'Thesis Statement – A thesis is a direct statement that explains the topic of your essay, what you believe about that topic, and why you believe it. A thesis statement is made up of three different parts. Every thesis needs these three things: Identification (What is the topic you are talking about? Claim (What do you believe about the topic?), and Direction (What are the 3 main reasons you can support your claim? This will basically outline the body paragraphs of your essay.)',
    videos: [
      {id: '4PACV', label: 'Pros and Cons', url: process.env.REACT_APP_FOURTH_VIDEO_PROS_CONS, lazyLoad: true},
      {id: '4TSSV', label: 'Thesis Statement', url: process.env.REACT_APP_FOURTH_VIDEO_THESIS_STATEMENT, lazyLoad: true},
    ],
  },
  {
    id: 'panel4',
    ariaControls: 'panel4d-content',
    headerId: 'panel4d-header',
    topic: 'Topic 4: Essay Outline & Essay Structure',
    details: 'The essay outline is the structure of the essay which is divided into three sections – introduction, body, and conclusion. This unit focuses on developing an argumentative essay in which the students investigate a topic, collect data, and evaluate the content to then establish a position in a concise manner.',
    videos: [
      {id: '4ESIPV', label: 'Essay Structure and Introductory Paragraph', url: process.env.REACT_APP_FOURTH_INTRO_PARA, lazyLoad: true},
    ],
  },
  {
    id: 'panel5',
    ariaControls: 'panel5d-content',
    headerId: 'panel5d-header',
    topic: 'Topic 5: Essay Paragraphs',
    details: 'The Essay paragraphs presents a strong argumentative topic. The introductory paragraph presents the opening statement and the thesis statement. The body paragraphs present and explain the cons and pros (establish position in a concise manner). The conclusion paragraphs wraps up the argument and present the final conclusion.',
    videos: [
      {id: '4WMPV', label: 'Writing Middle Paragraphs', url: process.env.REACT_APP_FOURTH_MIDDLE_PARA, lazyLoad: true},
      {id: '4CCPV', label: 'Concluding Paragraphs', url: process.env.REACT_APP_FOURTH_CONCLUDING_PARA, lazyLoad: true},
      {id: '4AEPV', label: 'Argumentative Essay Practice', url: process.env.REACT_APP_FOURTH_ARGUMENT_ESSAY_PRAC, lazyLoad: true},
    ],
  },
  {
    id: 'panel6',
    ariaControls: 'panel6d-content',
    headerId: 'panel6d-header',
    topic: 'Topic 6: Informative Discourse',
    details: 'Informative discourse is expository writing where the writer intends to inform, educate, or instruct its audience on a particular topic. This type of writing creates authentic pieces such as business letters, report writing, statistical reports, job applications, expository essays, notices, email writing,advertisements, and completing forms.',
    videos: [
      {id: '4ARWV', label: 'Article Writing', url: process.env.REACT_APP_FOURTH_ARTICLE_WRITING, lazyLoad: true},
      {id: '4EMWV', label: 'Email Writing', url: process.env.REACT_APP_FOURTH_EMAIL_WRITING, lazyLoad: true},
      {id: '4LECMV', label: 'Letter Complaint', url: process.env.REACT_APP_FOURTH_LETTER_COMPLAINT, lazyLoad: true},
      {id: '4NOWV', label: 'Notice Writing', url: process.env.REACT_APP_FOURTH_NOTICE_WRITING, lazyLoad: true},
    ],
  }
];

export const frenchCourseTopicMaterials = [
  {
    id: 'panel1',
    ariaControls: 'panel1d-content',
    headerId: 'panel1d-header',
    topic: 'French Topics',
    details: 'The introductory to French course is designed for students with no knowledge of French. Classes use a communicative approach, and the emphasis is on oral proficiency, comprehension, and expression. Reading and writing skills are also developed. Through extensive practice in class, students acquire the basic vocabulary and constructions of French, providing a sound basis for further studies. The main goal of this course is to give students an introduction to the French language and culture through a communicative and project-based approach.',
    videos: [
      {id: '1FGV', label: 'Greetings', url: process.env.REACT_APP_FRENCH_VIDEO_GREETINGS, lazyLoad: true},
      {id: '1FBIV',  label: 'Basic Introductions', url: process.env.REACT_APP_FRENCH_VIDEO_INTRODUCTIONS, lazyLoad: true},
      {id: '1FLAV', label: "L'Alphabet", url: process.env.REACT_APP_FRENCH_VIDEO_ALPHABET, lazyLoad: true},
      {id: '1FLCV',  label: 'Les Couleurs', url: process.env.REACT_APP_FRENCH_VIDEO_COLORS, lazyLoad: true},
      {id: '1LJDLSV', label: 'Les Jours de la Semaine', url: process.env.REACT_APP_FRENCH_VIDEO_DAYS_WEEK, lazyLoad: true},
      {id: '1LMDLV', label: 'Les Mois de Lannee', url: process.env.REACT_APP_FRENCH_VIDEO_MONTHS_YEAR, lazyLoad: true},
      {id: '1FLNV', label: 'Les Nombres', url: process.env.REACT_APP_FRENCH_VIDEO_NUMBERS, lazyLoad: true},
      {id: '1FLFV', label: 'La Famille', url: process.env.REACT_APP_FRENCH_VIDEO_FAMILY, lazyLoad: true},
      {id: '1FLFELLV', label: 'Les Fruits et les Legumes', url: process.env.REACT_APP_FRENCH_VIDEO_FRUITS, lazyLoad: true},
      {id: '1FLRV', label: 'Le Restaurant', url: process.env.REACT_APP_FRENCH_VIDEO_RESTAURANT, lazyLoad: true},
    ],
  },
];
